import React, { createContext, useContext, useState, FC, ReactNode, useCallback } from "react";

// Define the types for the score and updateScore function
type ScoreContextType = {
  score: number;
  updateScore: (newScore: number) => void;
};

// Create a context for the score
const ScoreContext = createContext<ScoreContextType | undefined>(undefined);

// Provider component to wrap your application
export const ScoreProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [score, setScore] = useState<number>(0);

  // Function to update the score, ensuring only two decimal places
// Function to update the score, ensuring only two decimal places
const updateScore = useCallback((newScore: number) => {
  // Check for infinity using Number.isFinite()
  if (!Number.isFinite(newScore)) {
    console.error("Encountered infinity value for score. Setting to 0.");
    setScore(0);
  } else {
    setScore((prevScore) => Math.round(newScore * 100) / 100); // Use functional form of setScore
  }
}, []);


  return (
    <ScoreContext.Provider value={{ score, updateScore }}>
      {children}
    </ScoreContext.Provider>
  );
};

// Custom hook to use the score value and update functions
export const useScore = (): ScoreContextType => {
  const context = useContext(ScoreContext);
  if (!context) {
    throw new Error('useScore must be used within a ScoreProvider');
  }
  return context;
};